import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const About: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FFF5F5', py: 4 }}>
      <Container maxWidth="md">
        <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#363636' }}>
            About WTG!
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            WTG! is a cutting-edge platform developed by Tenaba, Inc. that revolutionizes the way people explore cities. 
            Our AI-powered walking tour generator creates personalized, engaging, and informative tours tailored to your interests and time constraints.
          </Typography>

          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Whether you're a history buff, art enthusiast, or just looking to discover hidden gems, WTG! helps you experience 
            cities in a unique and meaningful way. Our technology combines artificial intelligence with local knowledge to create 
            tours that are both educational and entertaining.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Our Mission
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            At Tenaba, Inc., we believe that technology should enhance human experiences. Our mission is to make city exploration 
            more accessible, engaging, and personalized for everyone. We're committed to creating tools that help people connect 
            with the places they visit on a deeper level.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Contact Us
          </Typography>
          
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            Have questions or feedback? We'd love to hear from you! Reach out to us at{' '}
            <a href="mailto:bmorioka@tenaba.com" style={{ color: '#4ECDC4', textDecoration: 'none' }}>
              bmorioka@tenaba.com
            </a>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default About; 